<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  
      
		
        <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
			<el-form-item>
			    <el-form-item>
                    <el-select v-model="goodstype" @change="changegoodstype" placeholder="请选择数据同步类型">
                        <el-option v-for="(item,index) in goodstypelists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>
		  	</el-form-item>
      	    <el-form-item v-if="goodstype==1">
			    <el-button type="danger" icon="el-icon-plus" round @click="getmallgoodslists">添加同步商品</el-button>
		  	</el-form-item>
			<el-form-item v-if="goodstype==2">
			    <el-button type="warning" icon="el-icon-upload2" round @click="getallgoods">上传商品</el-button>
		  	</el-form-item>
			<el-form-item>
			    <el-button type="success" icon="el-icon-setting" round @click="sysgoods" :disabled="sysgoodslists.length > 0 ? false :  true">执行同步</el-button>
		  	</el-form-item>
			<el-form-item>
			    <div style="color:#F56C6C;font-size:13px;font-weight:500;">已选择商品：{{sysgoodslists.length}} 个</div>
		  	</el-form-item>
	    </el-form>

		<div class="backborder2" style="margin-top:10px">
			<div class="cz-mall-goods-sys-inventory-out" v-if="sysgoodslists.length > 0">
				<ul>
					<li v-for="(item,index) in sysgoodslists" :key="index">
					   <div class="cz-mall-goods-sys-inventory-goodslists">
					   	   <div class="cz-mall-goods-sys-inventory-goodslists-in">
							  <div class="cz-mall-goods-sys-inventory-goodslists-main">
								  <div class="cz-mall-goods-sys-inventory-goodslists-name">{{item.name}}</div>
								  <div class="cz-mall-goods-sys-inventory-goodslists-spec">ID：{{item.id}}，sku：{{item.sku}}，重量：{{item.weight}}kg，规格：{{item.property_name}}</div>
							  </div>
						   </div>
						   <div class="cz-mall-goods-sys-inventory-goodslists-nums">
						   	   数量：
						   	   <span class="cz-mall-goods-sys-inventory-goodslists-nums-base" :style=" item.result && item.result=='success' ? 'text-decoration:line-through' : '' ">
								  {{item.lastinventory}}	  
								</span>
							   <span class="cz-mall-goods-sys-inventory-goodslists-nums-update" v-if="item.updateinventory">{{item.updateinventory}}</span>
						   </div>
						   <div class="cz-mall-goods-sys-inventory-goodslists-nums">
						   	   <el-button type="danger" round size="small" :disabled="item.result ? true : false" @click="delsysgoods(index)">删除</el-button>
						   </div>
					   </div>
					   <div class="cz-mall-goods-sys-inventory-end">
					   	   <div v-if="item.result">
							  	<div class="cz-mall-goods-sys-inventory-end-result" v-if="item.result">{{item.result=='success' ? '同步成功' : '同步失败'}}</div>
								<div class="cz-mall-goods-sys-inventory-end-error" v-if="item.result=='error'">（{{item.msg}}）</div>
						   </div>
					   </div>
					</li>
				</ul>
			</div>
			<div v-if="sysgoodslists.length==0" class="cz-mall-goods-sys-inventory-goodslists-no">
				<img src="../../assets/packet.png" />
				<span>还没有需要同步的商品，请选择需要同步的商品信息</span>
			</div>
		</div>


		<el-dialog title="查看商品" :visible.sync="goodsDialog" width="70%" top="10vh">
			<el-form :inline="true" class="demo-form-inline" ref="query" :model="query" size="small">
				<el-form-item>
					<el-select v-model="goodsquery.brandid" clearable remote  filterable placeholder="按品牌" @change="goodsquery.ischange=true">	            
                        <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                            <span style="float: left">{{item.name}}</span>
                            <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                        </el-option>              
                    </el-select>          
				</el-form-item>
				<el-form-item>
                    <el-input placeholder="请输入关键字" v-model="goodsquery.key" clearable @keyup.enter.native="getgoodslistsdata" @change="goodsquery.ischange=true" />
                </el-form-item>
				<el-form-item>
                    <el-button type="primary" round size="small" @click="getgoodslistsdata">搜索</el-button>
                </el-form-item>
				<el-form-item>
                    <el-button type="" round size="small" @click="deltempgoods">清空已选商品</el-button>
                </el-form-item>
				<el-form-item>
                    <div style="color:#F56C6C;font-size:13px;font-weight:500;">已选中：{{tempgoods.length}}个商品</div>
                </el-form-item>
	    	</el-form>

			<el-table :data="goodslists" ref="goodsmultipleTable" v-loading="goodsquery.loading" @select="goodsselectchange" @select-all="goodsallselectchange">
				<el-table-column type="selection" width="60" align="center"></el-table-column>
				<el-table-column label="id" width="130" align="center">
					<template slot-scope="scope">
						<span style="float:left;width:100%">{{scope.row.id}}</span>
						<span style="float:left;width:100%;font-size:12px;color:#909399" v-if="scope.row.sku!=null && scope.row.sku!=''">（{{scope.row.sku}}）</span>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" min-width="300">
					<template slot-scope="scope">
						<div class="goods-infos-main">
							<img :src="scope.row.img=='' ? require('../../assets/default_img_mini.png') : scope.row.img" class="cz-mall-goods"/>
						</div>
						<div class="goods-infos-name-main">
							<span class="goods-infos-name-name">{{scope.row.name}}</span>
							<span class="goods-infos-name-spec"  v-if="scope.row.property_name!=''">规格：{{scope.row.property_name}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="品牌" width="130">
					<template slot-scope="scope">
						<span style="float:left;font-size:13px">{{scope.row.brandname}}</span>
					</template>
              	</el-table-column>
				<el-table-column label="重量（kg）" width="130" align="center">
					<template slot-scope="scope">
						<div>{{scope.row.weight}}</div>
					</template>
              	</el-table-column>
				<el-table-column label="可用库存（剩余库存-冻结库存）" width="150" align="center">
					<template slot-scope="scope">
						<div>{{scope.row.lastinventory}}</div>
					</template>
              	</el-table-column>
			</el-table>
			<div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="skupageSizeChange"
	            @current-change="skupageCurrentChange"
	            :current-page="goodsquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="goodsquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="goodsquery.rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
			<div slot="footer" class="dialog-footer">
            	<el-button size="small" @click="goodsDialog = false">取 消</el-button>
            	<el-button size="small" type="primary" @click="savegoodstosys">保 存</el-button>
            </div>
		</el-dialog>

		<div class="cz-mall-goods-sys-show-loading" v-if="showloadings">
			<div class="cz-mall-goods-sys-show-loadin-out" style="width:50%;">
				<div class="cz-mall-goods-sys-show-loadin-content">数据处理中，需要点时间，请耐心等待...</div>
				<div class="cz-mall-goods-sys-show-loadin-percent">
					<div class="cz-mall-goods-sys-show-loadin-percent-in" :style="percent==0 ? 'width:0px;padding:0' : 'width:calc('+percent+'% - 20px);padding-right:20px' ">{{percent}}%</div>
				</div>
			</div>
		</div>

           
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
        url:this.GLOBAL.domain+"GoodsSys/index",
        transitionshow:true,
        actionauth:'', //功能权限
		sysgoodslists:[],
		goodstype:1,
		oldgoodstype:1,
		goodstypelists:[{id:1,name:'部分同步'},{id:2,name:'全部同步'}],
		goodsDialog:false,
		goodsquery: {
			act:'getgoodslists',
			token:this.$cookies.get('token'),
			brandid:'',
			key:'',
			loading:false,
			ischange:false,
			p:1,
			rollpage:10,
			rows:0
		},
		goodsloading:false,
		goodslists:[],
		brandlists:[],
		tempgoods:[],

		showloadings:false,
		allrows:0,
		uprows:0,
		percent:0,
        
    }
  },
  
  mounted(){
    this.getactionauth();
	this.getBrand(0);
  },
  
  methods:{

	//执行数据同步
	sysgoods() {
		if(this.sysgoodslists.length==0) {this.$message.error("请选择要同步库存的商品信息");return false;}

		//开启加载特效
		this.startloading();
		this.allrows=this.sysgoodslists.length; //获取总的数据数量
		var rollpage=20; //设置每次同步条数
		var p=Math.floor(this.allrows/rollpage); //获取页数
		p +=this.allrows%rollpage > 0 ? 1 : 0;

		//定时处理数据
		this.uprows=0;
		this.percent=0;
		var localpercent=0;
		var isopen=true;

		//定时往服务器里提交数据
		var _this=this;
		var localpage=0;
		var spage=0;
		var epage=0;

		var draggo=setInterval(function() {

			//执行完毕，退出定时任务
			if(_this.allrows==_this.uprows) {
				_this.editbrandloading(); 
				clearInterval(draggo);
			}

			if(isopen) {
				isopen=false;
				localpage++;

				if(localpage > p) {_this.editbrandloading();clearInterval(draggo);} //页数超出当前页数时直接退出

				//计算抓取的开始、结束记录
				spage=(localpage-1)*rollpage;
				epage=localpage*rollpage-1;
				var propertyids=[];
				//抓取目标规格id
				for(var i=0;i < _this.allrows;i++) {
					if(i >= spage && i <= epage ) propertyids.push(_this.sysgoodslists[i].id);
				}

				//提交服务器进行处理
				propertyids=propertyids.join(',');
				//获取待同步数据
				var resource = _this.$resource(_this.url);		  
				resource.save({act:'saveupdategoods',propertyids:propertyids,token:_this.$cookies.get('token')}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') _this.$router.push('/login')
						_this.$message.error(res.data.Message);
						_this.uprows=_this.allrows;
					}else{
						var result = JSON.parse(Base64.decode(res.data.Data));
						if(result.length > 0) { //更新数据

							var resultnums=0; //设置执行条数
							var sysgoodsids=[]; //获取当前同步商品规格id
							_this.sysgoodslists.forEach(function(ttt,iii) {sysgoodsids.push(ttt.id)});
							result.forEach(function(ttt,iii) {
								
								//更新目标商品同步结果
								if(sysgoodsids.indexOf(ttt.id) >= 0) {
									var sort=sysgoodsids.indexOf(ttt.id);
									_this.sysgoodslists[sort].updateinventory=ttt.updateinventory;
									_this.sysgoodslists[sort].result=ttt.result;
									_this.sysgoodslists[sort].msg=ttt.msg;
								}

								//计算百分比
								_this.uprows++;
								_this.uprows >= _this.allrows ? _this.uprows=_this.allrows : '';
								_this.uprows==_this.allrows ? localpercent=100 : localpercent=Math.round(_this.uprows/_this.allrows*100);

								resultnums++;
								if(resultnums==result.length) {
									_this.percent=localpercent;
									isopen=true; //更新完成打开开关
								}

							});

						}else { //跳出逻辑
							_this.percent=100;
							_this.uprows=_this.allrows;
						}
								

					}
				});


			}

		},2000);


	},


	//上传商品信息
	getallgoods() {
		if(this.goodstype==1) {this.$message.error('部分商品同步无需使用该操作');return false;}

		//开启等待特效
		this.startloading();
		this.allrows=0;
		this.uprows=0;

		//获取在售商品总数
		var resource = this.$resource(this.url);		    
	    resource.query({act:'get_goods_from_sys_mall_nums',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
				//关闭特效
				this.editbrandloading();

			}else{
			    var result = JSON.parse(Base64.decode(res.data.Data));
				this.allrows=result.rows > 0 ? result.rows : 0;
				if(this.allrows==0) {
					this.$message.error('您还没添加有待同步的商品');
					this.editbrandloading(); //关闭特效
					return false;
				}

				//定时往服务器提取数据
				var _this=this;
				var ids=[];
				var localpercent=0;
				this.sysgoodslists.forEach(function(ttt,idx) {ids.push(ttt.id)});

				var isopen=true;
				var draggo=setInterval(function() {
					//商品上传完成，关闭特效，并退出
					if(_this.allrows==_this.uprows) {
						_this.editbrandloading(); //关闭特效;
						clearInterval(draggo);
					}

					if(isopen) {
						isopen=false;

						//获取待同步数据
						resource.save({act:'getuploadgoods',token:this.$cookies.get('token')}).then((res) => {
							if(res.data.Result>0){
								if(res.data.Result=='70001') _this.$router.push('/login')
								_this.$message.error(res.data.Message);
								_this.uprows==_this.allrows;
							}else{
								var result = JSON.parse(Base64.decode(res.data.Data));
								var nums=0;
								if(result.length > 0) { //搜集商品填充
									result.forEach(function(tte,iii) {
										ids.indexOf(tte.id)==-1 ? _this.sysgoodslists.push(tte) : '';
										if(ids.indexOf(tte.id)==-1) ids.push(tte.id);
										_this.uprows++;

										_this.uprows >= _this.allrows ? _this.uprows=_this.allrows : '';
										_this.uprows==_this.allrows ? localpercent=100 : localpercent=Math.round(_this.uprows/_this.allrows*100);

										nums++;
										if(nums==result.length) {
											_this.percent=localpercent;
											isopen=true;
										}
									});

								}else {
									_this.uprows=_this.allrows;
									_this.percent=100;
									isopen=true;
								}

							}
						});
					}

				},2000);



			}
	    }).catch((res) => {
	        //关闭特效暂停
			this.editbrandloading();
	    });


	},


	//////////////////////////////
	//等待组件

	//开启组件等待特效
	startloading() {
		this.showloadings=true;
		this.percent=0;
	},

	//关闭等待组件特效
	editbrandloading() {
		this.showloadings=false;
	},

	//等待组件
	///////////////////////////////

	/** 获取功能权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

	/** 获取品牌 **/
	getBrand(isshow){
	    var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
	    resource.query({act:'lists',token:this.$cookies.get('token'),jdshow:0,rollpage:100000}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.brandlists = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
	},

    /** 获取线上商城商品信息 **/
	getmallgoodslists() {
		this.goodsquery.brandid='';
		this.goodsquery.key='';
		this.goodsquery.p=1;
		this.goodsquery.rollpage=10;
		this.goodsquery.rows=0;
		this.tempgoods=[];
		this.goodsDialog=true;
		this.getgoodslistsdata();
	},

	//获取线上商城商品信息
	getgoodslistsdata() {
		if(this.goodsquery.ischange) {
			this.goodsquery.p=1;
			this.goodsquery.rollpage=10;
		}

		this.goodsquery.loading=true;
		var resource = this.$resource(this.url);
	    resource.save(this.goodsquery).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
                this.goodsquery.loading=false;
		    }else{
		        this.goodslists = JSON.parse(Base64.decode(res.data.Data));
                this.goodsquery.rows=parseInt(res.data.count);
                this.goodsquery.loading=false;
                if(this.goodsquery.ischange) this.goodsquery.ischange=false;

				var ids=[];
				var _this=this;
				this.tempgoods.forEach(function(item,index) {
					ids.push(item.id);
				});
				setTimeout(function() {
					_this.goodslists.forEach(function(e,index){  
						ids.indexOf(e.id) >=0 ? _this.$refs.goodsmultipleTable.toggleRowSelection(e) : '';
					});
				},200);  

		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
            this.goodsquery.loading=false;
	    });
	},

	skupageSizeChange(val) {
        this.goodsquery.rollpage = val;
        this.getgoodslistsdata();
    },
    skupageCurrentChange(val) {
        this.goodsquery.p = val;
        this.getgoodslistsdata();
    },

	/////////////////////////////////
	//勾选商品

	deltempgoods() {
		this.tempgoods=[];
		this.getgoodslistsdata();
	},

	//单选商品信息
	goodsselectchange(val,row) {
        var ids=[];
		this.tempgoods.forEach(function(item,index) {
			ids.push(item.id);
		});
		
		var number=ids.indexOf(row.id);
		number==-1 ? this.tempgoods.push(row) : this.$delete(this.tempgoods,number);
    },

	//勾选/取消勾选全部商品
    goodsallselectchange(val) {
        var _this=this;
        var number=-1;
        if(val.length > 0) { //新增商品
            val.forEach(function(item,i) {
				number=-1;
				_this.tempgoods.forEach(function(tt,ii) {
					if(item.id==tt.id) number=ii;
				});
				if(number==-1) _this.tempgoods.push(item);
            });

        }else { //删除商品
            this.goodslists.forEach(function(item,i) {
				number=-1;
				_this.tempgoods.forEach(function(tt,ii) {
					if(item.id==tt.id) number=ii;
				});
				if(number > -1) _this.$delete(_this.tempgoods,number);
            });
        }
    },

	//保存选中商品
	savegoodstosys() {
		if(this.tempgoods.length==0) {
			this.$message.error('请选择要同步的商品信息');
			return false;
		}

		var ids=[];
		var _this=this;
		this.sysgoodslists.forEach(function(item,index) {
			ids.push(item.id);
		});

		this.tempgoods.forEach(function(tt,ii) {
			ids.indexOf(tt.id) >= 0 ? '' : _this.sysgoodslists.push(tt);
		});

		this.tempgoods=[];
		this.goodsDialog=false;
	},

	//删除选中商品
	delsysgoods(index) {
		this.$delete(this.sysgoodslists,index);
	},

	//勾选商品
	/////////////////////////////////

	//修改同步数据类型
	changegoodstype() {
		this.$confirm('此操作会将已选择或添加的商品信息清空, 是否继续 ?', '提示', { type: 'warning' }).then(() => {
              this.oldgoodstype=this.goodstype;
			  this.sysgoodslists=[];

        }).catch(() => {
              this.goodstype=this.oldgoodstype;

        });
	},

    
     
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.cz-mall-goods-sys-inventory-out {display:inline-block;width:100%;overflow-x:hidden;overflow-y:auto;}
.cz-mall-goods-sys-inventory-out::-webkit-scrollbar {width:10px;height:10px;}
.cz-mall-goods-sys-inventory-out::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.cz-mall-goods-sys-inventory-out::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}

.cz-mall-goods-sys-inventory-out ul {padding:0;margin:0;}
.cz-mall-goods-sys-inventory-out ul li {float:left;width:calc(100% - 40px);height:70px;border-bottom:1px solid #EBEEF5;padding:0 20px;}
.cz-mall-goods-sys-inventory-goodslists-in {float:left;width:60%;height:70px;display:flex;justify-content:left;align-items:center;}
.cz-mall-goods-sys-inventory-goodslists-main {float:left;width:100%;}
.cz-mall-goods-sys-inventory-goodslists-name {float:left;width:100%;font-size:13px;line-height:25px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.cz-mall-goods-sys-inventory-goodslists-spec {float:left;width:100%;font-size:12px;line-height:25px;color:#999999;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.cz-mall-goods-sys-inventory-goodslists-nums {float:left;width:20%;height:70px;display:flex;justify-content:left;align-items:center;font-size:13px;}
.cz-mall-goods-sys-inventory-goodslists-nums-base {color:#666666;font-size:14px;font-weight:500;}
.cz-mall-goods-sys-inventory-goodslists-nums-update {color:#F56C6C;font-size:14px;font-weight:500;margin-left:5%}
.cz-mall-goods-sys-inventory-goodslists-nums {float:left;width:20%;height:70px;display:flex;justify-content:left;align-items:center;}
.cz-mall-goods-sys-inventory-goodslists-no {width:100%;min-height:200px;display:flex;justify-content:center;align-items:center;}
.cz-mall-goods-sys-inventory-goodslists-no img {width:40px;height:40px;}
.cz-mall-goods-sys-inventory-goodslists-no span {margin-left:1%;font-size:14px;color:#999999;}

.cz-mall-goods-sys-inventory-goodslists {float:left;width:80%;height:70px;border-right:1px solid #EBEEF5;}
.cz-mall-goods-sys-inventory-end {float:left;width:calc(20% - 1px);height:70px;display:flex;justify-content:center;align-items:center;}
.cz-mall-goods-sys-inventory-end-result {font-size:13px;color:#666666;width:100%;font-size:13px;line-height:21px;text-align:center;}
.cz-mall-goods-sys-inventory-end-error {width:100%;color:#F56C6C;font-size:12px;line-height:21px;text-align:center;}

.goods-infos-main {background:rgba(221,221,221,.5);display:flex;align-items: center;justify-content: center;float:left;width:60px;height:60px;border:1px solid #dddddd;border-radius:5px}
.goods-infos-main img {max-width:80%;max-height:80%}
.goods-infos-name-name {float:left;width:84%;margin-left:5%;font-size:.8rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.goods-infos-name-spec {float:left;width:95%;margin-left:5%;color:#909399;font-size:12px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}


.cz-mall-goods-sys-show-loading {display:flex;justify-content:center;align-items:center;position:fixed;width:100%;height:100%;top:0;left:0;background:rgba(0,0,0,.8);z-index:1000;}
.cz-mall-goods-sys-show-loadin-out {width:50%;}
.cz-mall-goods-sys-show-loadin-content {float:left;width:100%;text-align:center;transition:.5s all;color:#ffdd03;font-size:13px;line-height:23px;-webkit-animation-timing-function:ease-in-out;-webkit-animation-name:msgnotice;-webkit-animation-duration:1000ms;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;}
.cz-mall-goods-sys-show-loadin-percent {float:left;width:calc(40% - 4px);margin-left:30%;height:35px;margin-top:20px;overflow:hidden;border-radius:25px;border:2px solid #ffdd03;}
.cz-mall-goods-sys-show-loadin-percent-in {float:left;height:35px;color:#333336;border-radius:25px;background:#ffdd03;font-size:13px;line-height:23px;font-weight:550;display:flex;justify-content:right;align-items:center;overflow:hidden;transition:.5s all}

@-webkit-keyframes msgnotice {
   0% {
	    opacity:1;
		text-shadow:0 0 10px #fff;
   }
   100% {
	    opacity:0;
		text-shadow:0 0 0 #fff;
   }
}
</style>


// WEBPACK FOOTER //
// src/components/mall/SysGoodsinventory.vue